import { css } from '@emotion/react';

import type { Theme } from '@kc-console/common-ui';

export interface LnbItemButtonStyleOptions {
  collapsed?: boolean;
  hasSubMenu?: boolean;
}

export const getLnbItemButtonStyle = (theme: Theme) => {
  return css`
    background-color: ${theme.color['surface/neutral/weak/default']};
    color: ${theme.color['text/weak/default']};
    transition: 200ms;

    &:hover {
      background-color: ${theme.color['surface/neutral/weak/hover']};
    }

    &[data-active='active'] {
      background-color: ${theme.color['surface/neutral/weak/select']};
      color: ${theme.color['text/default']};
    }

    &:active {
      background-color: ${theme.color['surface/neutral/weak/press']};
    }

    &:focus-visible {
      position: relative;
      ${theme.mixins.focusRing('inside')};
    }
  `;
};

export const getCollapsedLnbItemButtonStyle = (
  theme: Theme,
  options?: LnbItemButtonStyleOptions,
) => {
  const { hasSubMenu } = options ?? {};

  return css`
    background-color: ${theme.color['surface/neutral/weak/default']};
    color: ${hasSubMenu ? theme.color['icon/weaker/default'] : theme.color['icon/strong/default']};
    transition: 200ms;

    &:hover {
      background-color: ${theme.color['surface/neutral/weak/hover']};
      color: ${hasSubMenu ? theme.color['icon/weaker/hover'] : theme.color['icon/strong/hover']};
    }

    &[data-active='active'] {
      background-color: ${theme.color['surface/neutral/weak/select']};
      color: ${hasSubMenu ? theme.color['icon/weaker/hover'] : theme.color['icon/default']};
    }

    &:active {
      background-color: ${theme.color['surface/neutral/weak/press']};
      color: ${hasSubMenu ? theme.color['icon/weaker/hover'] : theme.color['icon/strong/hover']};
    }

    &:focus-visible {
      position: relative;
      ${theme.mixins.focusRing('inside')};
    }
  `;
};
